export const GREETING_CACHE_TTL_MS = 8 * 60 * 60 * 1000;
export const GREETING_CACHE_KEY = 'fongpt-greeting-selection-v1';

export type GreetingBucket = 'morning' | 'daytime' | 'evening';

export interface GreetingSelection {
  bucket: GreetingBucket;
  choiceIndex: number;
  expiresAt: number;
}

function bucketForHour(hour: number): GreetingBucket {
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'daytime';
  return 'evening';
}

function isGreetingSelection(
  value: unknown,
  now: number
): value is GreetingSelection {
  if (!value || typeof value !== 'object') return false;
  const selection = value as Partial<GreetingSelection>;
  return (
    ['morning', 'daytime', 'evening'].includes(selection.bucket || '') &&
    Number.isInteger(selection.choiceIndex) &&
    Number(selection.choiceIndex) >= 0 &&
    Number(selection.choiceIndex) < 3 &&
    typeof selection.expiresAt === 'number' &&
    selection.expiresAt > now
  );
}

export function getGreetingSelection(
  storage: Pick<Storage, 'getItem' | 'setItem'>,
  now = Date.now(),
  random = Math.random
): GreetingSelection {
  try {
    const cached = JSON.parse(storage.getItem(GREETING_CACHE_KEY) || 'null');
    if (isGreetingSelection(cached, now)) return cached;
  } catch {
    // A malformed or unavailable cache is safely replaced below.
  }

  const selection: GreetingSelection = {
    bucket: bucketForHour(new Date(now).getHours()),
    choiceIndex: Math.min(2, Math.max(0, Math.floor(random() * 3))),
    expiresAt: now + GREETING_CACHE_TTL_MS
  };

  try {
    storage.setItem(GREETING_CACHE_KEY, JSON.stringify(selection));
  } catch {
    // The greeting still works when browser storage is unavailable.
  }
  return selection;
}
